export default __webpack_public_path__ + "static/media/tasty.f215a8e4.png";